<div class="form-field-date">
  <mat-form-field appearance="fill">
    <mat-label>{{label}}</mat-label>

    <input
      id="date"
      [formGroup]="form"
      [placeholder]="placeholder"
      matInput
      [matDatepicker]="picker"
      [max]="maxDate"
      [min]="minDate"
      [value]="value"
      (dateChange)="onChange($event)"
      class="form-control"
      (click)="picker.open()"
      readonly
    />
    <mat-datepicker #picker></mat-datepicker>
    <div class="icon-date" (click)="onOpen()"><img src="assets/icons/icon_calendar.svg" alt="Calendario" /></div>

    <!-- <span><img src="assets/icons/calendar.svg" alt="Calendario" /></span> -->
  </mat-form-field>
</div>
